<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content">
    <!-- 戻る -->
    <div *ngIf="!confirmFlag">
      <div class="return">
        <button pButton type="button" label="一覧へ戻る" icon="pi pi-angle-left" class="p-button-text"
          (click)="moveC261()"></button>
      </div>
      <div class="title-container p-col-12 p-grid p-jc-center">
        <div class="p-col-12 title-large">
          <p>{{ caseStudy?.seedsOrganizationName + ' × ' + caseStudy?.needsOrganizationName }}</p>
        </div>

        <div class="p-col-12 p-d-flex p-jc-center p-flex-column">
          <div class="case-study-img-container p-d-flex p-jc-center">
            <img alt="取組概要画像" [src]="caseStudy?.image" />
          </div>
        </div>
        <div class="p-col-12" *ngIf="caseStudy?.overview">
          <div class="sub-title">
            実施概要
          </div>
          <p>{{ caseStudy?.overview }}</p>
        </div>
        <div class="p-col-12" *ngIf="caseStudy?.title || caseStudy?.title_nursery">
          <div class="sub-title">
            感想
          </div>
          <div *ngIf="caseStudy?.title">
            <div class="support-title">
              中学校・高校等
            </div>
            <p>{{ caseStudy?.title }}</p>
          </div>
          <div *ngIf="caseStudy?.title_nursery">
            <div class="support-title">
              保育所・幼稚園等
            </div>
            <p>{{ caseStudy?.title_nursery }}</p>
          </div>
        </div>

        <div class="p-col-12" *ngIf="caseStudy?.initial_overview || caseStudy?.initial_overview_nursery">
          <div class="sub-title">
            工夫したこと
          </div>
          <div *ngIf="caseStudy?.initial_overview">
            <div class="support-title">
              中学校・高校等
            </div>
            <p>{{ caseStudy?.initial_overview }}</p>
          </div>
          <div *ngIf="caseStudy?.initial_overview_nursery">
            <div class="support-title">
              保育所・幼稚園等
            </div>
            <p>{{ caseStudy?.initial_overview_nursery }}</p>
          </div>
        </div>

        <div class="p-col-12" *ngIf="caseStudy?.school_name || caseStudy?.school_name_nursery">
          <div class="sub-title">
            得られた成果
          </div>
          <div *ngIf="caseStudy?.school_name">
            <div class="support-title">
              中学校・高校等
            </div>
            <p>{{caseStudy?.school_name}}</p>
          </div>
          <div *ngIf="caseStudy?.school_name_nursery">
            <div class="support-title">
              保育所・幼稚園等
            </div>
            <p>{{caseStudy?.school_name_nursery}}</p>
          </div>
        </div>

        <div class="p-col-12" *ngIf="caseStudy?.match_information">
          <div class="sub-title">
            マッチング情報
          </div>
          <p>{{caseStudy?.match_information}}</p>
        </div>
        <!--div class="p-col-12 p-d-flex p-jc-center">
          <button pButton type="button" label="戻る" (click)="back()"></button>
        </div-->
      </div>
    </div>
    <div *ngIf="confirmFlag">
      <div class="title-container p-col-12 p-grid p-jc-center">
        <div class="p-col-12">
          <div class="sub-title1">
            <li>中学校・高校等</li>
          </div>
          <p>{{ caseStudy?.seedsOrganizationName }}</p>
        </div>
        <div class="p-col-12">
          <div class="sub-title1">
            <li>保育所・幼稚園等</li>
          </div>
          <p>{{ caseStudy?.needsOrganizationName }}</p>
        </div>
        <div class="p-col-12 p-d-flex p-jc-center p-flex-column">
          <div class="sub-title1">
            <li>写真</li>
          </div>
          <div class="case-study-img-container p-d-flex p-jc-center">
            <img alt="取組概要画像" [src]="caseStudy?.image" />
          </div>
        </div>
        <div class="p-col-12">
          <div class="sub-title1">
            <li>実施概要</li>
          </div>
          <p>{{ caseStudy?.overview }}</p>
        </div>
        <div class="p-col-12">
          <div class="sub-title1">
            <li>感想（中学校・高校等）</li>
          </div>
          <p>{{ caseStudy?.title }}</p>
        </div>
        <div class="p-col-12">
          <div class="sub-title1">
            <li>感想（保育所・幼稚園等）</li>
          </div>
          <p>{{ caseStudy?.title_nursery }}</p>
        </div>
        <div class="p-col-12">
          <div class="sub-title1">
            <li>工夫したこと（中学校・高校等）</li>
          </div>
          <p>{{ caseStudy?.initial_overview }}</p>
        </div>
        <div class="p-col-12">
          <div class="sub-title1">
            <li>工夫したこと（保育所・幼稚園等）</li>
          </div>
          <p>{{ caseStudy?.initial_overview_nursery }}</p>
        </div>
        <div class="p-col-12">
          <div class="sub-title1">
            <li>得られた成果（中学校・高校等）</li>
          </div>
          <p>{{caseStudy?.school_name}}</p>
        </div>
        <div class="p-col-12">
          <div class="sub-title1">
            <li>得られた成果（保育所・幼稚園等）</li>
          </div>
          <p>{{caseStudy?.school_name_nursery}}</p>
        </div>
        <div class="p-col-12">
          <div class="sub-title1">
            <li>マッチング情報</li>
          </div>
          <p>{{caseStudy?.match_information}}</p>
        </div>
      </div>
    </div>